export enum PaymentProviders {
  Heartland = 'heartland',
  Iroquois = 'iroquois',
}

export enum AccountTypes {
  Checking = 'checking',
  Savings = 'savings',
}

export enum CheckTypes {
  Personal = 'personal',
  Business = 'business',
}
